export const isRequestedStaff = (value) =>
  value === true || value === 1 || value === "1" || value === "true" || value === "yes";

const normalizeStaffId = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") {
    return normalizeStaffId(value.id ?? value.value ?? value.staff_id);
  }
  return String(value).trim();
};

export const hasSelectedStaff = (selection = {}) => {
  const staffId = normalizeStaffId(selection.staff_id ?? selection.staffId);
  return staffId !== "" && staffId !== "0";
};

export const isNoPreferenceSelection = (selection = {}) =>
  isRequestedStaff(selection.no_preference) ||
  isRequestedStaff(selection.noPreference) ||
  isRequestedStaff(selection.noPref);

/**
 * Resolve the persisted `is_requested` flag for an appointment payload.
 *
 * "Requested staff" means the client asked for one specific therapist.  That
 * intent only exists on the client: once a booking is posted, "No Preference"
 * is indistinguishable from a chosen therapist because availability resolves
 * an actual staff member either way.  An explicit flag always wins; otherwise
 * the flag is derived from whether a concrete staff id was selected.
 */
export const requestedStaffFlagForSelection = (selection = {}) => {
  if (isNoPreferenceSelection(selection)) return false;
  const explicit = selection.is_requested;
  if (explicit !== undefined && explicit !== null && explicit !== "") {
    return isRequestedStaff(explicit);
  }
  return hasSelectedStaff(selection);
};
